import {
  Box,
  Flex,
  Loading,
  Skeleton,
  useDesktopMediaQuery,
  useMobileMediaQuery,
  useTabletMediaQuery,
} from '@iheartjane/reefer';

import { useSafeEcommApp } from '@jane/shared/providers';

import {
  BlockSkeleton,
  CarouselSkeleton,
  FilterSkeleton,
  MenuProductDetail,
  MenuProductDetailMobile,
  ProductDetailDesktop,
  ProductDetailMobile,
  ProductGridSkeleton,
  RoundSkeleton,
} from './skeletonComponents';

export const ProductSearchSkeleton = () => (
  <Flex justifyContent="center" width="100%">
    <Box width="100%" maxWidth="1440px">
      <ProductGridSkeleton />
    </Box>
  </Flex>
);

export const StoreMenuSkeleton = () => {
  const isMobile = useMobileMediaQuery({});
  return (
    <Flex
      justifyContent="center"
      width="100%"
      px={isMobile ? 24 : 64}
      pt={isMobile ? 0 : 24}
    >
      <Box width="100%">
        <FilterSkeleton />
        <CarouselSkeleton />
        <CarouselSkeleton />
        <CarouselSkeleton />
        <CarouselSkeleton />
      </Box>
    </Flex>
  );
};

export const MenuSkeleton = () => {
  const isMobile = useMobileMediaQuery({});

  const { appMode } = useSafeEcommApp();
  const isMarketplace = appMode === 'default';
  const headerHeight = isMarketplace ? (isMobile ? '260px' : '308px') : '95px';

  return (
    <Flex flexDirection="column" width="100%" alignItems="center">
      <Skeleton.Bone height={headerHeight} width="100%" />
      <Flex
        flexDirection="column"
        p={isMobile ? 24 : 64}
        width="100%"
        maxWidth="1440px"
      >
        <Skeleton.Bone height={isMobile ? 520 : 600} />
      </Flex>
    </Flex>
  );
};

export const ProductDetailSkeleton = () => {
  const isMobile = useMobileMediaQuery({});

  return (
    <Box width="100%" maxWidth="1024px" mx="auto">
      {isMobile ? <ProductDetailMobile /> : <ProductDetailDesktop />}
    </Box>
  );
};

export const MenuProductDetailSkeleton = () => {
  const isMobile = useMobileMediaQuery({});

  return (
    <Box width="100%" maxWidth="1488px" mx="auto">
      {isMobile ? <MenuProductDetailMobile /> : <MenuProductDetail />}
    </Box>
  );
};

export const MenuTitleSkeleton = () => {
  const isTablet = useTabletMediaQuery({ width: 'max' });

  return (
    <Flex
      alignItems={isTablet ? 'flex-start' : 'center'}
      width="100%"
      gap={isTablet ? 16 : 24}
    >
      <RoundSkeleton diameter={isTablet ? 64 : 96} />
      <Flex width="100%" flexDirection="column" gap={8}>
        <Skeleton.Bone width={150} height={40} />
        <Skeleton.Bone width={isTablet ? 300 : 600} height={30} />
      </Flex>
    </Flex>
  );
};

export const CheckoutSkeleton = () => {
  const isDesktop = useDesktopMediaQuery({ size: 'sm', width: 'min' });
  return (
    <Flex
      maxWidth="1440px"
      width="100%"
      flexDirection={isDesktop ? 'row' : 'column'}
      gap={24}
      p={isDesktop ? 64 : 12}
      m="auto"
    >
      <Flex width="100%" flexDirection="column" gap={24}>
        <BlockSkeleton height={50} />
        <BlockSkeleton height={200} />
        <BlockSkeleton height={200} />
        <BlockSkeleton height={200} />
        <BlockSkeleton height={200} />
        <BlockSkeleton height={200} />
      </Flex>
      <Flex width="100%">
        <BlockSkeleton height={740} />
      </Flex>
    </Flex>
  );
};

export const FullPageLoading = () => {
  const { isIframe } = useSafeEcommApp();

  return (
    <Box height={isIframe ? '700px' : '100vh'}>
      <Box position="relative" width="100%" height="100%">
        <Loading size="lg" />
      </Box>
    </Box>
  );
};
